import { generateKeywordsQueryForOr } from '@smarttransit/common'
import { apiRequests, mapApiRequests } from '../utilities/axios-factory'
import store from '../store'

function getTransportationProfileGeolocationMetadata ({ transportationProfileId, shortcodeId }) {
  return mapApiRequests.post('/v1/geo-location/transportation-profile/metadata/', { transportationProfileId, shortcodeId }, {
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then((result) => {
    return result.data
  })
}

function getRoutesForDateTime ({ transportationProfileId }) {
  return apiRequests.get(`/v1/transportation-profile/${transportationProfileId}/transportation-profile-routes/valid/`, {
    params: { dateTime: new Date().toISOString() },
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then((result) => {
    return result.data
  })
}

async function getTransportationRoutes ({ transportationProfileId }) {
  const result = await apiRequests.get(`/v1/transportation-profile/${transportationProfileId}/transportation-profile-routes/detailed/`, {
    headers: {
      Authorization: store.getters.tokenId
    }
  })

  return result?.data
}

function getTransportationProfileRouteById ({ transportationProfileRouteId }) {
  return apiRequests.get(`/v1/transportation-profile-route/${transportationProfileRouteId}/`, {
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then((result) => {
    return result.data
  })
}

function findTransportationProfiles ({ transportationProfileId, shortcodeId, includeTransportationProfileRoutes = false }) {
  return apiRequests
    .get('/v1/transportation-profile/', {
      params: {
        filter: {
          where: {
            id: transportationProfileId,
            shortcodeId: shortcodeId
              ? encodeURIComponent(shortcodeId)
              : undefined
          },
          include: includeTransportationProfileRoutes ? ['transportationProfileRoutes'] : undefined
        }
      },
      headers: {
        Authorization: store.getters.tokenId
      }
    })
    .then(result => {
      return result.data
    })
}

function getBusStops (filter) {
  return apiRequests.get('/v1/bus-stop/', {
    params: { filter },
    headers: { Authorization: store.getters.tokenId }
  }).then((result) => {
    return result.data
  })
}

function getBusStopsForRoute (transportationProfileRouteId) {
  return apiRequests.get(`/v1/transportation-profile-route/${transportationProfileRouteId}/bus-stops/`, {
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then((result) => {
    return result.data
  })
}

function getRouteFareByOriginAndDestination ({
  transportationProfileRouteId,
  startLongitude,
  startLatitude,
  endLongitude,
  endLatitude,
  busStopIdFrom,
  busStopIdTo
}) {
  return apiRequests.get('/v1/route-fare/fare-by-origin-destination/', {
    params: {
      agencyId: 'STRANSITGHA',
      transportationProfileRouteId,
      startLongitude,
      startLatitude,
      endLongitude,
      endLatitude,
      busStopIdFrom,
      busStopIdTo,
      excludeLinestringCheck: false
    },
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then((result) => {
    return result.data
  })
}

function purchaseOneTimeTicket ({
  ticketCreationDate,
  reservedTicketDate,
  agentProfileId,
  prepaidGuest,
  allowNegativeBalance,
  passengerProfileId,
  transportationProfileId,
  transportationProfileRouteId,
  startLongitude,
  startLatitude,
  endLongitude,
  endLatitude,
  busStopIdFrom,
  busStopIdTo
}) {
  return apiRequests.post(`/v1/agent-profile/${agentProfileId}/passenger-one-time-ticket/`, {
    ticketCreationDate,
    reservedTicketDate,
    prepaidGuest,
    allowNegativeBalance,
    passengerProfileId,
    transportationProfileId,
    transportationProfileRouteId,
    startLongitude,
    startLatitude,
    endLongitude,
    endLatitude,
    busStopIdFrom,
    busStopIdTo
  }, {
    headers: {
      Authorization: store.getters.tokenId,
      'x-agent-authorization': store.getters?.passengerAuthorizationToken?.tokenId
    },
    timeout: 70000
  }).then((result) => {
    return result.data
  })
}

function findTransportationProfileEvents ({ keywords, dateFrom, dateTo, limit, offset, order }) {
  const filter = {
    limit,
    offset,
    order: order || 'eventDate DESC'
  }

  const andConditions = []

  if (keywords) {
    andConditions.push({ or: generateKeywordsQueryForOr(keywords, ['name']) })
  }

  if (dateFrom || dateTo) {
    const range = {}

    if (dateFrom) {
      range.gte = dateFrom
    }

    if (dateTo) {
      range.lte = dateTo
    }

    andConditions.push({ eventDate: range })
  }

  if (andConditions.length) {
    filter.where = { and: andConditions }
  }

  return apiRequests.get('/v1/transportation-profile-event/', {
    params: { filter },
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then(function (result) {
    return result.data
  })
}

function getTransportationProfileEventById ({ id }) {
  return apiRequests.get('/v1/transportation-profile-event/' + id + '/', {
    headers: {
      Authorization: store.getters.tokenId
    }
  }).then(function (result) {
    return result.data
  })
}

function createEventTicketAsAgent ({
  agentProfileId,
  passengerProfileId,
  transportationProfileEventId,
  eventDate,
  returnEventDate,
  pickupBusStopId,
  selectedPickupTime,
  selectedReturnPickupTime,
  allowNegativeBalance,
  prepaidGuest
}) {
  return apiRequests.post('/v1/agent-profile/' + agentProfileId + '/passenger-event-ticket/', {
    passengerProfileId,
    transportationProfileEventId,
    eventDate,
    returnEventDate,
    pickupBusStopId,
    selectedPickupTime,
    selectedReturnPickupTime,
    allowNegativeBalance,
    prepaidGuest
  }, {
    headers: {
      Authorization: store.getters.tokenId,
      'x-agent-authorization': store.getters && store.getters.passengerAuthorizationToken && store.getters.passengerAuthorizationToken.tokenId
    }
  }).then(function (result) {
    return result.data
  })
}

function getEventCapacityStatus ({ id }) {
  return apiRequests.get('/v1/transportation-profile-event/' + id + '/capacity/', {
    headers: { Authorization: store.getters.tokenId }
  }).then(function (result) {
    return result.data
  })
}

export {
  getTransportationProfileGeolocationMetadata,
  getRoutesForDateTime,
  findTransportationProfiles,
  getTransportationProfileRouteById,
  getBusStopsForRoute,
  getRouteFareByOriginAndDestination,
  purchaseOneTimeTicket,
  getTransportationRoutes,
  findTransportationProfileEvents,
  getTransportationProfileEventById,
  createEventTicketAsAgent,
  getEventCapacityStatus,
  getBusStops
}
